import { useEffect, type RefObject } from 'react'

/** Вызвать `handler`, когда клик/тап произошёл вне `ref` (и по Escape). */
export function useClickOutside<T extends HTMLElement>(
  ref: RefObject<T>,
  handler: () => void,
  active = true,
): void {
  useEffect(() => {
    if (!active) return
    function onPointer(ev: PointerEvent) {
      const el = ref.current
      if (el && ev.target instanceof Node && !el.contains(ev.target)) handler()
    }
    function onKey(ev: KeyboardEvent) {
      if (ev.key === 'Escape') handler()
    }
    document.addEventListener('pointerdown', onPointer)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('pointerdown', onPointer)
      document.removeEventListener('keydown', onKey)
    }
  }, [ref, handler, active])
}
